import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetSubscriptionCommitmentOptionsAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   */
  constructor({config, getSubscriptionCommitmentOptionsAdsService}) {
    super({config})
    this._config = config
    this._getSubscriptionCommitmentOptionsAdsService = getSubscriptionCommitmentOptionsAdsService
  }

  @tracer({metric: 'GetSubscriptionCommitmentOptionsAdsUseCase#execute'})
  @inlineError
  async execute() {
    const [getSubscriptionCommitmentOptionsAdsServiceError, getSubscriptionCommitmentOptionsAdsServiceResponse] =
      await this._getSubscriptionCommitmentOptionsAdsService.execute()
    return getSubscriptionCommitmentOptionsAdsServiceError
      ? Promise.reject(getSubscriptionCommitmentOptionsAdsServiceError)
      : getSubscriptionCommitmentOptionsAdsServiceResponse.toJSON()
  }
}
